export default __webpack_public_path__ + "static/media/benefit6.6eaa69ae.svg";